/* eslint-disable import/prefer-default-export */
export const RequestInspectionJobAdapter = (params) => {
  const transformParams = () => {
    const { pagination, search, sorted, filtered, draft } = params;
    let payload = {
      pageNo: pagination.pageNo,
      pageSize: pagination.pageSize,
    };
    if (sorted.by) {
      payload = {
        ...payload,
        sortBy: `${sorted.by}:${sorted.direction}`,
      };
    }
    if (search.by && search.keywords) {
      payload = {
        ...payload,
        searchBy: search.by,
        keywords: search.keywords,
      };
    }
    if (filtered.result && !filtered.result.includes('all')) {
      // Default will get all result;
      payload = {
        ...payload,
        result: filtered.result,
      };
    }
    if (filtered.status && !filtered.status.includes('all')) {
      // Default will get all status;
      payload = {
        ...payload,
        status: filtered.status,
      };
    }
    if (draft) {
      payload = {
        ...payload,
        isPublished: false,
      };
    }
    return payload;
  };
  return { transformParams };
};

export const RequestInspectionInspectorWithJobAdapter = (params) => {
  const transformParams = () => {
    const { pagination, search, sorted, filtered, ...extra } = params;
    let payload = {
      pageNo: pagination.pageNo,
      pageSize: pagination.pageSize,
      ...extra,
    };
    if (search.by && search.keywords) {
      payload = {
        ...payload,
        searchBy: search.by,
        keywords: search.keywords,
      };
    }
    if (filtered.result && !filtered.productTags.includes('all')) {
      // Default will get all result;
      payload = {
        ...payload,
        productTagIds: filtered.productTags,
      };
    }
    if (filtered.status && !filtered.inspectors.includes('all')) {
      // Default will get all status;
      payload = {
        ...payload,
        inspectorIds: filtered.inspectors,
      };
    }
    if (filtered.status && !filtered.locations.includes('all')) {
      // Default will get all status;
      payload = {
        ...payload,
        areas: filtered.locations,
      };
    }
    if (filtered.status && !filtered.status.includes('all')) {
      // Default will get all status;
      payload = {
        ...payload,
        status: filtered.status,
      };
    }

    return payload;
  };
  return { transformParams };
};
